import React from "react"
import { useMediaQuery } from "react-responsive"
import { useLoginContext } from "src/hooks/useLoginContext"
import { getLabel } from "src/modules/helper"
import { Box, Grid } from "src/UILibrary"

type Props = {
  item: any
  handleSelected?: any
}

export const UserTableItem = ({ item, handleSelected }: Props) => {
  const isPC = useMediaQuery({ query: "(min-width: 1400px)" })
  const isTablet = useMediaQuery({ query: "(min-width: 1200px)" })

  const { areas } = useLoginContext()

  return (
    <Box
      sx={{
        ":hover": { opacity: 0.8, cursor: "pointer" },
      }}
      onClick={() => handleSelected(item)}
    >
      {isTablet ? (
        <Grid
          container
          sx={{
            mt: "0px",
            height: "32px",
            borderBottom: "1px dotted #D4D3D7",
            minHeight: "80px",
          }}
        >
          <Grid
            item
            className="notosans weight500"
            color="text.primary"
            md={isPC ? 2 : isTablet ? 2 : 1}
            sm={12}
            xs={12}
            fontSize={14}
            sx={{ my: "auto", px: "20px" }}
          >
            {item.lastName ? `${item.lastName} ${item.firstName}` : item.companyName}
          </Grid>
          <Grid
            item
            className="notosans weight500"
            color="text.primary"
            md={isPC ? 2 : isTablet ? 3 : 1}
            sm={12}
            xs={12}
            fontSize={13}
            sx={{ my: "auto", px: "20px" }}
          >
            {getLabel(areas, item.areaId as number)}
          </Grid>
          <Grid
            item
            className="notosans weight500 restrict_line"
            color="text.primary"
            md={isPC ? 6 : isTablet ? 3 : 1}
            sm={12}
            xs={12}
            fontSize={13}
            sx={{ my: "auto", px: "20px" }}
          >
            {item.email}
          </Grid>
          <Grid
            item
            className="notosans weight500"
            color="text.primary"
            md={isPC ? 2 : isTablet ? 4 : 1}
            sm={12}
            xs={12}
            fontSize={12}
            sx={{ my: "auto", px: "20px" }}
          >
            {item.createdAt?.substring(0, 16).replace("T", " ")}
          </Grid>
        </Grid>
      ) : (
        <Box display="display" sx={{ borderBottom: "1px dotted #D4D3D7" }}>
          <Box display="flex">
            <Box
              className="notosans weight500"
              color="text.primary"
              fontSize={14}
              sx={{ mt: "10px", ml: "10px" }}
            >
              {item.lastName ? `${item.lastName} ${item.firstName}` : item.companyName}
            </Box>
            <Box sx={{ mt: "12px", ml: "30px", width: "100%" }}>
              {getLabel(areas, item.areaId as number)}
            </Box>
          </Box>
          <Box sx={{ p: "10px" }}>{item.email}</Box>
          <Box sx={{ p: "0px 10px", mb: "10px" }}>
            {item.createdAt?.substring(0, 16).replace("T", " ")}
          </Box>
        </Box>
      )}
    </Box>
  )
}
